import React, { useEffect, useState } from "react";

import { Route, HashRouter, BrowserRouter as Router, Switch } from "react-router-dom";

import RetrieveChart from "./Components/RetrieveChart";
import PrivateRoute from "./Components/Auth/PrivateRoute";
import NodeAlarm from "./Components/NodeAlarm";
import Navbar from "./Components/Navbar";
import axiosInstance from "./shared/api";
import { RemoteMainLayout } from "./pages/Remote";

import Login from "../src/pages/Login/index";
import Dashboard from "../src/pages/Dashboard/index";
import NodeSummary from "./pages/NodeSummary";

import 'semantic-ui-css/semantic.min.css';
import axios from "axios";
import Register from "./pages/Register";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer} from 'react-toastify';
import Alarm from "./pages/Alarm/Alarm";
import BlockSettingDb from "./pages/Remote/BlockSettingDb";
import ManualOperation from "./pages/Remote/ManualOperation";
import SessionSetting from "./pages/Remote/SessionSetting";
import SettingIndex from "./pages/Remote/SettingIndex";
import Schedueler from "./Containers/Schedueler";

function App() {
	const [logo, setLogo] = useState('farmsens.png')

	function getUserNodeCategory() {
		axiosInstance.get(`${process.env.REACT_APP_API_URL}/getUserNodeCategory/${localStorage.getItem("cloudatik")}/`)
		.then(res => {
			getImage(res.data.permission.logo)
		}).catch(err => {
			console.log(234, err)
		})
	}

	useEffect(() => {
		getUserNodeCategory()
	}, [localStorage.getItem("cloudatik")])
	
	// If image exist in public folder then use it. Else use default farmsens.png
	function getImage(logoName) {
		if (logoName) { 
			setLogo(logoName)
		} else {
			setLogo('farmsens.png')
		}
	}

	return (
		<div>
			<Router>
        		<Switch>
				<Route path="/register" component={Register} exact/>
				<Route path="/alarm/:id" component={()=>{
					return (<Alarm logo={logo}/>)
				}} exact/>
				
				<HashRouter>
					{localStorage.getItem("cloudatik") && <Navbar logo={logo}/>}
					<div style={{ paddingTop: 30 }}>
						<Route path="/" component={Login} exact />
						<PrivateRoute
							path="/retrieve-chart"
							auth={localStorage.getItem("cloudatik")}
							comp={RetrieveChart}
						/>
						<PrivateRoute
							path="/node-config"
							auth={localStorage.getItem("cloudatik")}
							comp={NodeAlarm}
						/>
						<PrivateRoute
							path="/remote/:device/:serial/:device_id/:telemetry/:page?"
							auth={localStorage.getItem("cloudatik")}
							comp={RemoteMainLayout}
						/>
						<PrivateRoute
							path="/remote-agrirrig-rad/block/:device/:device_id"
                            exact
							auth={localStorage.getItem("cloudatik")}
							comp={BlockSettingDb}
						/>
						<PrivateRoute
							path="/remote-agrirrig-rad/manual/:device/:device_id"
                            exact
							auth={localStorage.getItem("cloudatik")}
							comp={ManualOperation}
						/>
						<PrivateRoute
							path="/remote-agrirrig-rad/session/:device/:device_id"
                            exact
							auth={localStorage.getItem("cloudatik")}
							comp={SessionSetting}
						/>
						<PrivateRoute
							path="/schedueler/:device/:device_id"
                            exact
							auth={localStorage.getItem("cloudatik")}
							comp={Schedueler}
						/>

						{/* v2 */}
						<PrivateRoute
							path="/v2/dashboard"
							auth={localStorage.getItem("cloudatik")}
							comp={Dashboard}
						/>
						<PrivateRoute
							path="/v2/node"
							auth={localStorage.getItem("cloudatik")}
							comp={NodeSummary}
						/>
					</div>
				</HashRouter>
        		</Switch>
			</Router>
			<ToastContainer />
		</div>
	);
}

export default App;
